import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { ReactLenis, useLenis } from "lenis/react";
import { Toaster } from "sonner";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { WhatsAppFab } from "@/components/WhatsAppFab";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Capabilities from "@/pages/Capabilities";
import MissionVision from "@/pages/MissionVision";
import Products from "@/pages/Products";
import Industries from "@/pages/Industries";
import Enquiry from "@/pages/Enquiry";
import ReachUs from "@/pages/ReachUs";
import Admin from "@/pages/Admin";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  const lenis = useLenis();
  useEffect(() => {
    lenis?.scrollTo(0, { immediate: true });
    window.scrollTo(0, 0);
  }, [pathname, lenis]);
  return null;
};

function App() {
  return (
    <div>
      <BrowserRouter>
        <ReactLenis root options={{ lerp: 0.09, smoothWheel: true }}>
          <ScrollToTop />
          <Navbar />
          <main className="relative z-[2]">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/capabilities" element={<Capabilities />} />
              <Route path="/mission-vision" element={<MissionVision />} />
              <Route path="/products" element={<Products />} />
              <Route path="/industries" element={<Industries />} />
              <Route path="/enquiry" element={<Enquiry />} />
              <Route path="/reach-us" element={<ReachUs />} />
              <Route path="/admin" element={<Admin />} />
            </Routes>
          </main>
          <Footer />
          <WhatsAppFab />
          <Toaster position="bottom-right" richColors />
        </ReactLenis>
      </BrowserRouter>
    </div>
  );
}

export default App;
